import React from 'react';
import './styles/index.css';
import patrocinio1 from '../../assets/patrocinio1.jpg';
import patrocinio2 from '../../assets/patrocinio2.jpg';
import triple17 from '../../assets/triple17.png';
import triple17yeyo from '../../assets/Triple17yeyo2.png';
import logoDani from '../../assets/logoDani.png';
import logoPrima from '../../assets/LogoPrima.png';
import Cad from '../../assets/Cad.jpg';
import Lokyo from '../../assets/Lokyo.jpg';
import Cocktails from '../../assets/Cocktails.jpg';
import KingDart from '../../assets/KingDart.jpg';
import LogoRocha from '../../assets/LogoRocha.png';
import CollaboratorsSection from './CollaboratorsSection';

const SponsorsSection = React.forwardRef((props, ref) => {
  return (
    <div className="login-sponsors-banner" ref={ref}>
      <div className="sponsors-banner-content">
        <CollaboratorsSection titleClassName="sponsors-banner-title" titleTag="h3" />
        <h3 className="sponsors-banner-title">Nuestros Patrocinadores</h3>
        <div className="sponsors-banner-grid">
          <div className="sponsor-banner-item">
            <a
              href="https://www.instagram.com/lokkyokopas2/"
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-banner-with-image"
            >
              <img src={Lokyo} alt="Lokkyo Kopas" className="sponsor-banner-logo" />
              <span className="sponsor-banner-name">Lokkyo Kopas</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a href="https://www.instagram.com/kingdartleague/" target="_blank" rel="noopener noreferrer" className="sponsor-banner-with-image">
              <img src={KingDart} alt="Kings Dart League" className="sponsor-banner-logo" />
              <span className="sponsor-banner-name">Kings Dart League</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a href="https://www.instagram.com/triple_17_dartshop/" target="_blank" rel="noopener noreferrer" className="sponsor-banner-with-image">
              <img src={triple17yeyo} alt="Triple 17 Dartshop" className="sponsor-banner-logo sponsor-banner-logo--triple17" />
              <span className="sponsor-banner-name">Triple 17 Dartshop</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a href="https://www.instagram.com/club.dardos.pizarra/" target="_blank" rel="noopener noreferrer" className="sponsor-banner-with-image">
              <img src={patrocinio1} alt="Club de Dardos Pizarra" className="sponsor-banner-logo" />
              <span className="sponsor-banner-name">Club de Dardos Pizarra</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a
              href="https://www.instagram.com/salaalexs/"
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-banner-with-image"
            >
              <img src={patrocinio2} alt="Sala Alex´s" className="sponsor-banner-logo sponsor-banner-logo--large" />
              <span className="sponsor-banner-name">Sala Alex´s</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a
              href="https://www.instagram.com/recreativos_triple17/"
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-banner-with-image"
            >
              <img src={triple17} alt="Recreativos Triple 17" className="sponsor-banner-logo sponsor-banner-logo--triple17" />
              <span className="sponsor-banner-name sponsor-banner-name--desktop">
                Recreativos Triple 17
                <span className="sponsor-phone">640859577</span>
              </span>
              <span className="sponsor-banner-name sponsor-banner-name--mobile">Recreativos Triple 17</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a
              href="https://www.instagram.com/creadoaldetalle/"
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-banner-with-image"
            >
              <img src={Cad} alt="CREADO AL DETALLE" className="sponsor-banner-logo sponsor-banner-logo--large" />
              <span className="sponsor-banner-name">CREADO AL DETALLE</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a href="https://www.instagram.com/clubdedardos_cocktails/" target="_blank" rel="noopener noreferrer" className="sponsor-banner-with-image">
              <img src={Cocktails} alt="Club de Dardos Cocktails" className="sponsor-banner-logo sponsor-banner-logo--cocktails" />
              <span className="sponsor-banner-name">Club de Dardos Cocktails</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a href="https://www.instagram.com/bar_de_copas_rocha/" target="_blank" rel="noopener noreferrer" className="sponsor-banner-with-image">
              <img src={LogoRocha} alt="Bar de Copas Rocha" className="sponsor-banner-logo sponsor-banner-logo--rocha" />
              <span className="sponsor-banner-name">Bar de Copas Rocha</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a
              href="https://www.escobarmultitransportes.es/"
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-banner-with-image"
            >
              <img src={logoPrima} alt="Escobar Multitransportes" className="sponsor-banner-logo sponsor-banner-logo--large" />
              <span className="sponsor-banner-name">Escobar Multitransportes</span>
            </a>
          </div>
          <div className="sponsor-banner-item">
            <a
              href="https://wa.me/34656820537"
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-banner-with-image"
            >
              <img src={logoDani} alt="Dani" className="sponsor-banner-logo sponsor-banner-logo--large" />
              <span className="sponsor-banner-name">Daniel Berlanga 656 82 05 37</span>
            </a>
          </div>
        </div>
        <div className="sponsors-banner-footer">
          ¿Quieres ser patrocinador? <a href="https://wa.me/34627367531?text=Hola,%20estoy%20interesado%20en%20ser%20patrocinador%20de%20501%20Darts" target="_blank" rel="noopener noreferrer">Contáctanos</a>
        </div>
      </div>
    </div>
  );
});

SponsorsSection.displayName = 'SponsorsSection';

export default SponsorsSection;
